export function hasEventContext(lastKnownEventId: string | undefined): boolean {
  return typeof lastKnownEventId === "string" && lastKnownEventId.trim().length > 0;
}
